// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, PropTypes } from '@plesk/ui-library';
import { Route } from 'react-router-dom';
import RequireComponent from './RequireComponent';

const RouteRequire = ({ path, componentPath, ...props }) => (
    <Route
        path={path}
        render={({ location: { pathname, search, hash } }) => <RequireComponent componentPath={componentPath} dataPath={`${pathname}${search}${hash}`} />}
        {...props}
    />
);

RouteRequire.propTypes = {
    path: PropTypes.string.isRequired,
    componentPath: PropTypes.string.isRequired,
};

export default RouteRequire;



// WEBPACK FOOTER //
// ./plesk/RouteRequire.js